import { StatusOption } from '../../utils'

export enum PayScaleTypeEnum {
  BONUS = 'BONUS',
  DAILY_SALARY = 'DAILY_SALARY'
}

export const payScaleTypeEnumMapping: Record<PayScaleTypeEnum, StatusOption> = {
  BONUS: {
    label: 'Prime',
    variant: 'fushia'
  },
  DAILY_SALARY: {
    label: 'Rémunération journalière',
    variant: 'blue'
  }
}
